import { Flex } from '@/components';
import type { ProjectModel } from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import type { z } from 'zod';
import { PreviewRowStateProvider } from '../../../expenditure/_components/PreviewRowStateProvider';
import { RsBudgetAmountsTable } from './RsBudgetAmountsTable';

type Props = z.infer<typeof ProjectModel>;

export const RsProjectDetailedBreakdown: FC<Props> = (project) => {
  return (
    <PreviewRowStateProvider>
      <Flex vertical gap={16}>
        <RsBudgetAmountsTable
          inspectionEvaluation={project.inspectionEvaluation}
          subProjects={project.subProjects}
          fiscalYear={project.fiscalYear}
          editable={!project.isLocked}
        />
        {/* <ProjectOtherNotesInformation
          increaseDecreaseMainReason={project.increaseDecreaseMainReason}
          otherSpecialNotes={project.otherSpecialNotes}
          revenueSource={project.revenueSource}
          editable={!project.isLocked}
          isSkippedReview={project.skipAdministrativeReformTeamEvaluation}
        /> */}
      </Flex>
    </PreviewRowStateProvider>
  );
};
